import { Box, Button, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';

export const ShopifyIntegrationBanner = ({ shopify_enabled, shopify_integration: isShopifyConnected, onClose }) => {
  const navigate = useNavigate();

  return (
    <>
      {shopify_enabled && !isShopifyConnected && (
        <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
          <Typography variant="body1" sx={{ fontSize: '1.2rem', fontWeight: 'bold', textAlign: 'center', mr: '5rem' }}>
            Your Shopify store connection needs attention. Please review your settings to ensure orders continue to
            sync.
          </Typography>
          <Box mt={2} display="flex" justifyContent="space-between">
            <Button
              variant="contained"
              onClick={() => {
                navigate('/settings?tab=integrations');
              }}
              sx={{ marginLeft: 'auto' }}
            >
              Shopify Settings
            </Button>
          </Box>
          <IconButton aria-label="close" color="inherit" size="small" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
      )}
    </>
  );
};
